<div class="tabs">
  <ng-container *ngFor="let tab of _tabs; let i = index">
    <div class="tab-container" [rxRoleGuard]="tab.rejectedRoles" [class.disabled]="tab.disabled">
      <div class="tab" [ngClass]="{ selected: selected === i }" (click)="onTabClicked(tab, i)">
        <rx-button [id]="'tab-' + i">
          <ng-template *ngTemplateOutlet="tab.innerTemplate"></ng-template>
        </rx-button>
      </div>
    </div>
  </ng-container>
</div>
<div class="flex"></div>
